// Barras horizontales que filtran al tocarlas y barras verticales que crecen escalonadas.
import { F } from './formato';
import { useAncho } from './useAncho';

export type ItemBarra = { k: string; nombre: string; valor: number; detalle?: string; color?: string };

export function BarrasH({ items, fmt = F.n, onClick, sel, tono }: { items: ItemBarra[]; fmt?: (v: number) => string; onClick?: (it: ItemBarra) => void; sel?: string | null; tono?: 'bad' | 'ok' | 'warn' }) {
  if (!items.length) return <p className="vacio">Sin datos con este filtro.</p>;
  const max = Math.max(1, ...items.map((i) => i.valor));
  return (
    <div className="hb">
      {items.map((it, i) => {
        const clase = `hb-f${sel != null ? (sel === it.k ? ' sel' : ' apagado') : ''}`;
        const contenido = (
          <>
            <span className="hb-n" title={it.nombre}>
              {it.nombre}
            </span>
            <span className="hb-b">
              <i style={{ width: `${(100 * it.valor) / max}%`, background: it.color ?? (tono ? `var(--${tono})` : undefined), animationDelay: `${i * 25}ms` }} />
            </span>
            <span className="hb-v mono">{fmt(it.valor)}</span>
            {it.detalle ? <span className="hb-d">{it.detalle}</span> : null}
          </>
        );
        return onClick ? (
          <button key={it.k} type="button" className={clase} aria-pressed={sel === it.k} onClick={() => onClick(it)}>
            {contenido}
          </button>
        ) : (
          <div key={it.k} className={clase}>
            {contenido}
          </div>
        );
      })}
    </div>
  );
}

export function BarrasV({ valores, etiquetas, serie2, nombres, fmt = F.n, alto = 150 }: { valores: number[]; etiquetas: string[]; serie2?: number[]; nombres?: [string, string?]; fmt?: (v: number) => string; alto?: number }) {
  const [medir, W] = useAncho();
  const H = alto, mb = 22, mt = 8;
  const max = Math.max(1, ...valores, ...(serie2 ?? []));
  const n = valores.length || 1;
  const hueco = W / n, bw = hueco * (serie2 ? 0.36 : 0.62);
  const cada = Math.ceil(n / 12);
  return (
    <div ref={medir}>
      <svg viewBox={`0 0 ${W} ${H}`} className="bv crece" role="img" aria-label={nombres?.filter(Boolean).join(' y ') ?? 'Barras'}>
        {valores.map((v, i) => {
          const h = ((H - mb - mt) * v) / max;
          const x0 = i * hueco + (hueco - bw * (serie2 ? 2.1 : 1)) / 2;
          const h2 = serie2 ? ((H - mb - mt) * serie2[i]) / max : 0;
          return (
            <g key={i}>
              <rect x={x0} y={H - mb - h} width={bw} height={Math.max(h, 1)} rx={3} className="bv-r" style={{ animationDelay: `${i * 22}ms` }}>
                <title>{`${etiquetas[i]}: ${fmt(v)}${nombres?.[0] ? ` ${nombres[0].toLowerCase()}` : ''}`}</title>
              </rect>
              {serie2 ? (
                <rect x={x0 + bw * 1.1} y={H - mb - h2} width={bw} height={Math.max(h2, 1)} rx={3} className="bv-r2" style={{ animationDelay: `${i * 22 + 40}ms` }}>
                  <title>{`${etiquetas[i]}: ${fmt(serie2[i])}${nombres?.[1] ? ` ${nombres[1].toLowerCase()}` : ''}`}</title>
                </rect>
              ) : null}
              {i % cada === 0 ? (
                <text x={i * hueco + hueco / 2} y={H - 6} textAnchor="middle" className="eje">
                  {etiquetas[i]}
                </text>
              ) : null}
            </g>
          );
        })}
      </svg>
    </div>
  );
}
